<template>
  <h1
    class="tw:text-black tw:text-2xl tw:font-bold"
    :class="{ 'tw:mb-6': accommodationsAmount === 0 }"
    data-testid="billing-header"
  >
    {{ $t(title) }}
  </h1>
</template>
<script setup>
defineProps({
  title: String,
  accommodationsAmount: [Number, Boolean],
})
</script>
